import { gql } from "@apollo/client";

export const STAND_COMMENT_CREATE = gql`
    mutation StandCommentCreate($input: CommentFieldsInput!) {
        commentCreate(input: $input) {
            label
            message
            comment {
                id
                status
            }
        }
    }
`;

export const STAND_COMMENT_UPDATE = gql`
    mutation StandCommentUpdate($input: CommentFieldsInput!) {
        commentUpdate(input: $input) {
            label
            message
            comment {
                id
                status
            }
        }
    }
`;

export const STAND_COMMENT_DELETE = gql`
    mutation StandCommentDelete($id: ID!) {
        commentDelete(id: $id) {
            label
            message
        }
    }
`;

export const STAND_ATTACHMENT_CREATE = gql`
    mutation StandAttachmentCreate($ee_id: ID!, $file: Upload!, $model: AttachmentModelMorphedName!, $model_id: ID!) {
        attachmentCreate(ee_id: $ee_id, file: $file, model: $model, model_id: $model_id) {
            label
            message
            attachment {
                id
                path
                server_name
                original_name
                extension
                modelable_id
            }
        }
    }
`;

export const STAND_ATTACHMENT_DELETE = gql`
    mutation StandAttachmentDelete($id: ID!) {
        attachmentDelete(id: $id) {
            label
            message
        }
    }
`;
